import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { KnownCategories } from '../../viewmodels/AppViewModels';

const QUERY_BASE_KEY = 'template/industry/blogCategories';

export const useBlogCardsCategories = ({
	enabled = true,
	industry,
	withAll = false,
	withMyTemplates = false,
	impersonationContext,
	withDrafts = false,
}: {
	enabled?: boolean;
	industry: Api.Industry;
	withAll?: boolean;
	withMyTemplates?: boolean;
	withDrafts?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: async () => {
			let categories = await userSession.webServiceHelper.callAsync<string[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `template/${encodeURIComponent(industry)}/blogCategories`,
					impersonationContext,
				}),
				'GET'
			);

			categories = categories.filter(c => c !== 'Archived' && c !== 'Uncategorized');
			if (withMyTemplates) {
				categories.unshift(KnownCategories.MyTemplates);
			}

			if (withAll) {
				categories.unshift(KnownCategories.All);
			}
			if (withDrafts) {
				// Insert BlogPostDrafts at index 2 to place it after "All" and "MyTemplates" categories
				categories.splice(2, 0, KnownCategories.BlogPostDrafts);
			}
			return categories;
		},
		queryKey: [QUERY_BASE_KEY, industry, impersonationContext],
	});
};
